import React from "react";
import LegalShell from "@/components/LegalShell";

export default function CGU() {
  return (
    <LegalShell title="Conditions Générales d'Utilisation" lastUpdated="6 février 2026" testId="page-cgu">
      <h2>1. Objet</h2>
      <p>Les présentes Conditions Générales d'Utilisation (« CGU ») régissent l'accès et l'utilisation de la plateforme Student Hub (ci-après « le Service »), accessible à l'adresse <strong>studenthubfrance.fr</strong>. Le Service est édité par <strong>Jamira LHASSANI, entrepreneur individuel (SIRET 422 541 649 00022)</strong>.</p>
      <p>Le Service permet aux étudiants en France de centraliser leurs démarches administratives, leur recherche de logement, leurs documents personnels, et propose un abonnement Premium optionnel.</p>

      <h2>2. Acceptation</h2>
      <p>Toute création de compte vaut acceptation pleine et entière des présentes CGU. L'utilisateur doit être majeur (18 ans) ou disposer du consentement de son représentant légal.</p>

      <h2>3. Inscription et compte</h2>
      <ul>
        <li>L'inscription est gratuite et requiert un email valide et un mot de passe d'au moins 6 caractères.</li>
        <li>L'utilisateur s'engage à fournir des informations exactes et à jour.</li>
        <li>Chaque compte est personnel ; la cession ou le partage est interdit.</li>
        <li>L'utilisateur est responsable de la confidentialité de ses identifiants.</li>
      </ul>

      <h2>4. Service Premium</h2>
      <ul>
        <li>L'abonnement Premium est proposé au tarif de <strong>2,99 € TTC par mois</strong>, prélevé via Stripe (et prochainement PayPal).</li>
        <li>Un essai gratuit de 7 jours est offert à la première souscription, sans engagement.</li>
        <li>L'abonnement est résiliable à tout moment depuis l'espace utilisateur ou via le service de paiement. La résiliation prend effet à la fin de la période en cours.</li>
        <li>L'abonnement Premium est facturé 2,99 €/mois, sans engagement, annulable à tout moment depuis tes paramètres.</li>
      </ul>

      <h2>5. Règles d'utilisation</h2>
      <p>L'utilisateur s'engage à ne pas :</p>
      <ul>
        <li>Publier de contenu illégal, diffamatoire, haineux, raciste ou portant atteinte à la vie privée d'autrui ;</li>
        <li>Tenter de contourner les mécanismes de sécurité (rate limit, authentification) ;</li>
        <li>Faire un usage commercial ou de spam du mur communautaire ;</li>
        <li>Aspirer (scraping) ou copier en masse les contenus du Service.</li>
      </ul>

      <h2>6. Modération et suspension</h2>
      <p>L'éditeur se réserve le droit de suspendre ou supprimer tout compte ne respectant pas les CGU, sans préavis ni remboursement en cas de violation grave. Tout contenu signalé sera examiné sous 72 heures.</p>

      <h2>7. Disponibilité et limitation de responsabilité</h2>
      <p>Le Service est fourni « en l'état ». L'éditeur s'efforce d'assurer une disponibilité maximale mais ne peut garantir une continuité absolue (maintenance, incidents). Les informations administratives, juridiques et financières sont fournies à titre informatif et ne se substituent pas à un conseil professionnel.</p>

      <h2>8. Propriété intellectuelle</h2>
      <p>L'ensemble des contenus, marques, logos et bases de données sont la propriété de l'éditeur ou de leurs ayants droit. Toute reproduction sans autorisation est interdite.</p>

      <h2>9. Données personnelles</h2>
      <p>Le traitement des données est détaillé dans la <a href="/legal/confidentialite">Politique de confidentialité</a>.</p>

      <h2>10. Droit applicable et litiges</h2>
      <p>Les présentes CGU sont soumises au droit français. En cas de litige, les parties privilégieront un règlement amiable. À défaut, les tribunaux français compétents seront saisis. Les consommateurs européens peuvent recourir à la plateforme RLL : <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noreferrer">ec.europa.eu/consumers/odr</a>.</p>

      <h2>11. Modifications</h2>
      <p>L'éditeur peut modifier ces CGU à tout moment. Les utilisateurs sont notifiés par email ou bandeau 30 jours avant l'entrée en vigueur des changements substantiels.</p>
    </LegalShell>
  );
}
